import FileSaver from 'file-saver'
import { useCallback, useState } from 'react'
import { getAttachmentDriverFile } from 'repositories/BerthApi/getAttachmentDriverFile'
import { getAttachmentFile } from 'repositories/BerthApi/getAttachmentFile'

import { TYPE_BLOB_FILE_EXCEL } from 'constants/Attachment'
import { extractExtensionOfFileName as extractExtension } from 'utils/commonFunctions'

export type Attachment = {
  id: number | string
  name: string
  [key: string]: unknown
}

const useAttachmentFileDownload = (isDriverFile: boolean = false) => {
  const [error, setError] = useState<string | null>(null)

  const onClickFileDownload = useCallback(
    async (e: React.MouseEvent, attachment: Attachment) => {
      e.preventDefault()
      e.stopPropagation()
      if (!attachment?.id) return

      const { id, name } = attachment

      try {
        setError(null)
        const fetchFile = isDriverFile ? getAttachmentDriverFile : getAttachmentFile

        const extension = extractExtension(name)?.toLowerCase() || ''
        const typeOfFile = TYPE_BLOB_FILE_EXCEL[extension] || 'application/octet-stream'

        const resp = await fetchFile(id)
        if (resp?.data == null) {
          throw new Error('ファイルデータが空です')
        }

        const file = new Blob([resp.data], { type: typeOfFile })
        FileSaver.saveAs(file, name)
      } catch (err) {
        const message = err instanceof Error ? err.message : 'エラーが発生しました'
        setError(message)
      }
    },
    [isDriverFile]
  )

  return { onClickFileDownload, error }
}

export default useAttachmentFileDownload
